module.exports = __webpack_public_path__ + "img/dashboard.9ec84a5d.png";